import { DateTime } from '@ksyos/date-time';
import { OutpatientClinicEpisodeCategory } from '@common/contexts/support/domain/models/outpatientClinicEpisodeCategoryModel';
import { OutpatientClinicOrganization } from '@common/contexts/support/domain/models/outpatientClinicOrganizationModel';
import { OutpatientClinicPatient } from '@common/contexts/support/domain/models/outpatientClinicPatientModel';
import { OutpatientClinicPractitioner } from '@common/contexts/support/domain/models/outpatientClinicPractitionerModel';
import { OutpatientClinicTask } from '@common/contexts/support/domain/models/outpatientClinicTaskModel';
import type { ModelAsDto, ModelAsRepositoryResource } from '../../domain/types/modelType';
import { OutpatientClinicTaskType } from '../../domain/models/outpatientClinicTaskTypeModel';

export function outpatientClinicTaskMapper(
    task: OutpatientClinicTask | ModelAsDto<OutpatientClinicTask> | ModelAsRepositoryResource<OutpatientClinicTask>
) {
    return new OutpatientClinicTask({
        ...task,
        dateCompleted: task.dateCompleted ? DateTime.from(task.dateCompleted) : null,
        episodeCategory: new OutpatientClinicEpisodeCategory(task.episodeCategory),
        expectedDateCompleted: DateTime.from(task.expectedDateCompleted),
        patient: new OutpatientClinicPatient({
            ...task.patient,
            birthDate: DateTime.from(task.patient.birthDate),
        }),
        performerOrganization: new OutpatientClinicOrganization(task.performerOrganization),
        performerPractitioner: task.performerPractitioner
            ? new OutpatientClinicPractitioner(task.performerPractitioner)
            : null,
        type: new OutpatientClinicTaskType(task.type),
        updated_at: task.updated_at ? DateTime.from(task.updated_at) : null,
    });
}
